import type { ReactNode } from 'react';

export const symbol_wifi_add: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M740-240h-90q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h90v-90q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v90h90q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-90v90q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-90ZM480-800q120 0 228.5 40.5T909-645q11 9.1 16.5 21.23Q931-611.65 931-598q0 12-4.5 24T912-552l-66 66q-8 8-20.5 8t-20.5-8q-8-8-8-20.5t8-20.5l67-67q-87-68-184.5-107T480-740q-110 0-207.5 39T88-594l392 392 39-39q8-8 20.5-8t20.5 8q8 8 8 20.5t-8 20.5l-38 38q-9 9-20 13t-22 4q-11 0-22-4t-20-13L48-552q-9-9-14-21t-5-24q0-14 5.31-26.57Q39.62-636.13 51-645q92-74 200.5-114.5T480-800Zm0 329Z"
		/>
	</svg>
);
